import React from 'react';
import { cn } from '@/lib/utils';
import {widthClasses, type WidthProps} from "./Page.tsx";

interface PageContentProps extends React.HTMLAttributes<HTMLDivElement>, WidthProps {}

export function PageContent({ children, width = 'standard', className, ...props }: PageContentProps) {
    return (
        <div className={cn("mx-auto p-4 md:p-6", widthClasses[width], className)} {...props}>
            {children}
        </div>
    );
}